var render = function render(){var _vm=this,_c=_vm._self._c;return _c('uw-page',{attrs:{"title":"仪表盘"}},[_c('card-sale-base'),_c('el-row',{style:({ marginTop: '20px' }),attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":8}},[_c('card-workflow-list',{style:({ height: '450px' })})],1),_c('el-col',{attrs:{"span":8}},[_c('card-pm-working-ranking',{style:({ height: '450px' })})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }